var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import URLSearchParams from "url-search-params";
import { nonRedirectingMonsApiFetch } from "../utils/monsUtils";
var FETCH_PLACEMENT_PREFIX = "/communications/placements";
export function encodeSearchParams(searchParams, accountInfoParams) {
    var params = new URLSearchParams();
    params.set("pageSize", searchParams.page.size.toString());
    params.set("page", searchParams.page.current.toString());
    if (searchParams.sort.sortBy) {
        params.set("sortBy", searchParams.sort.sortBy);
    }
    if (searchParams.sort.sortDirection) {
        params.set("sortDirection", searchParams.sort.sortDirection);
    }
    if (searchParams.filter.notificationTypeId) {
        params.set("notificationTypeId", searchParams.filter.notificationTypeId);
    }
    if (searchParams.filter.search) {
        params.set("queryText", searchParams.filter.search);
    }
    if (searchParams.filter.applicationName) {
        params.set("applicationName", searchParams.filter.applicationName);
    }
    if (searchParams.filter.webpageId) {
        params.set("webpageId", searchParams.filter.webpageId);
    }
    if (searchParams.filter.status) {
        searchParams.filter.status.forEach(function (s) { return params.append("status", s); });
    }
    if (searchParams.filter.messageType) {
        searchParams.filter.messageType.forEach(function (m) { return params.append("messageType", m); });
    }
    if (searchParams.filter.tags) {
        searchParams.filter.tags.forEach(function (t) { return params.append("tags", t); });
    }
    params.set("aggregate", searchParams.isAggregated.toString());
    params.set("isGlobal", searchParams.isGlobal ? searchParams.isGlobal.toString() : false.toString());
    params.set("entityId", accountInfoParams.entityId);
    return params.toString();
}
export function fetchNotifications(placementType, searchParams, accountInfoParams) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _fetchNotifications(placementType, encodeSearchParams(searchParams, accountInfoParams))];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
function _fetchNotifications(placementType, params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = (params) ? "?" + params : params;
                    url = FETCH_PLACEMENT_PREFIX + "/" + placementType + params;
                    console.log("attempting fetch at '" + url + "'");
                    return [4 /*yield*/, nonRedirectingMonsApiFetch(url, {
                            method: 'GET'
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Bad response status " + response.status);
                        //todo: do we want different behaviors for certain error codes
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    //notifications will be null if middleware hits an error. If its supposed to return no notifications, it will be []
                    if (!result.notifications) {
                        throw new Error("Bad response");
                    }
                    // Temporarily add a simple id to aggregated notifications so that it is tracked more nicely than with "null"
                    // todo: We'll remove this the day we have ids on aggregated notifications.
                    result.notifications.forEach(function (n) {
                        if (n.aggregated && !n.eventId) {
                            n.eventId = n.notificationTypeId + "-aggregated";
                        }
                    });
                    return [2 /*return*/, result];
            }
        });
    });
}
